import { useCallback, useEffect, useState } from 'react';
import { getVouchersByPhone, updateVoucherDetails } from 'app/api/customer';
import Message from 'app/utils/Message';
import Toast from 'app/utils/Toast';
import { cancelCustomerVoucher } from 'app/api/voucher';
import { cancelPackage } from 'app/api/package';
import { isPackageRow } from 'app/components/PackageRow';
import { usePackageCollect } from 'app/components/PackageCollectPanel/usePackageCollect';
import { confirmAlert } from 'react-confirm-alert';
const useCustomerVouchers = () => {

  const [selectedVoucher, setSelectedVoucher] = useState(null);

  const sectionObj = {
    sectionTitle: 'Collection Panel',

    searchObj: {
      keys: [''],
      placeholder: 'Search by Phone number',
      searchType: 'server',
      handleSearch: (e) => {
        inputChangeHandler(e);
      },
    },
  };

  const [totalNumber, setTotalNumber] = useState(0);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [localSearch, setLocalSearch] = useState('');
  const [customerData, setCustomerData] = useState();

  function changeHandler(event) {
    const pageLength = event.target.value;
    setDataPerPage(pageLength);
    let count = Math.ceil(data.length / pageLength);
    setPageCount(count);
  }

  const [values, setValues] = useState({
    phoneNumber: '',
    voucherCode: '',
    serialNumber: '',
    status: '',
    //voucherId: ''
  });

  // Function to fetch data from the server based on current page and search value
  const fetchCustomerData = useCallback(
    async (page, searchValue) => {
      setPageLoading(true);
      try {
        const response = await getVouchersByPhone(
          searchValue,
          page,
          dataPerPage
        ); // Pass searchValue to API call
        if (response?.responseCode === 200) {
          const dataArr = response?.data?.data || [];
          // const newArray = dataArr.map((item) => ({

          // }));
          setData(dataArr);
          setFilteredData(dataArr);
          setCustomerData(response?.data?.customerData);
          const totalCount = response?.data?.count || 0;
          const tempcount = Math.ceil(totalCount / dataPerPage);
          setTotalNumber(totalCount);
          setPageCount(tempcount);
        } else {
          Toast.error(
            response?.response?.message || Message.Error.COMMON_MESSAGE
          );
        }
      } catch (error) {
        Toast.error(Message.Error.COMMON_MESSAGE);
      } finally {
        setPageLoading(false);
      }
    },
    [dataPerPage]
  );

  // Handle search input changes
  const inputChangeHandler = (value) => {
    setLocalSearch(value); // Update search value state
    setIsSearching(true); // Set flag to indicate search action
    setCurrentPage(1); // Reset to first page
  };

  // Handle page change
  // Effect to handle fetching data when currentPage or searchVal changes
  useEffect(() => {
    fetchCustomerData(currentPage, localSearch);
  }, [localSearch, currentPage, fetchCustomerData]);

  // A successful package collect refetches the current page; the panel closes itself.
  const packageCollect = usePackageCollect({
    onSuccess: () => fetchCustomerData(currentPage, localSearch),
  });

  function handleNew(data) {
    // Branch on the explicit row type before reading any voucher-only field: a
    // package row has no voucherId, and purchase ids and reservation ids collide.
    if (isPackageRow(data)) {
      packageCollect.openFor(data, customerData?.phone);
      return;
    }
    setSelectedVoucher(data);
    setValues((prev) => ({
      ...prev,
      phoneNumber: customerData?.phone,
      voucherCode: '',
      voucherId: data?.voucherId || '',
      status: 3,
    }));
    setIsFilterOpen(true);
  }

  async function handleSubmit() {
    setPageLoading(true);
    try {
      const response = await updateVoucherDetails(values);
      fetchCustomerData(currentPage, localSearch);
      if (response?.responseCode === 200) {
        Toast.success(response?.message);
      } else {
        Toast.error(
          response?.response?.message || Message.Error.COMMON_MESSAGE
        );
      }
    } catch (error) {
      Toast.error(Message.Error.COMMON_MESSAGE);
    } finally {
      setIsFilterOpen(false);
      setPageLoading(false);
    }
  }

  async function cancelWholePackage(packageRow) {
    setPageLoading(true);
    try {
      const response = await cancelPackage(
        packageRow?.purchaseId,
        customerData?.customerId
      );
      if (response?.responseCode === 200) {
        Toast.success(response?.message);
        fetchCustomerData(currentPage, localSearch);
      } else {
        Toast.error(
          response?.response?.message || Message.Error.COMMON_MESSAGE
        );
      }
    } catch (error) {
      Toast.error(Message.Error.COMMON_MESSAGE);
    } finally {
      setPageLoading(false);
    }
  }

  async function handleDelete(page, voucherdata) {
    // A package refunds its whole price in one credit, so it is confirmed once (D-15).
    // A single voucher cancel stays instant, exactly as before.
    if (isPackageRow(voucherdata)) {
      confirmAlert({
        title: '',
        message: Message.Package.CANCEL_CONFIRM,
        buttons: [
          {
            label: 'Yes',
            onClick: () => cancelWholePackage(voucherdata),
          },
          {
            label: 'No',
          },
        ],
        overlayClassName: 'overlay-custom-class-name',
      });
      return;
    }
    setPageLoading(true);
    try {

      const response = await cancelCustomerVoucher(
        voucherdata?.id,
        customerData?.customerId
      );
 
      if (response?.responseCode === 200) {
        Toast.success(response?.message);
        fetchCustomerData(currentPage, localSearch);
      } else {
        Toast.error(
          response?.response?.message || Message.Error.COMMON_MESSAGE
        );
      }
    } catch (error) {
      Toast.error(Message.Error.COMMON_MESSAGE);
    } finally {
      setPageLoading(false);
    }
  }
  return {
    changeHandler,
    pageLoading,
    filteredData,
    totalNumber,
    currentPage,
    dataPerPage,
    pageCount,
    sectionObj,
    handleNew,
    isFilterOpen,
    setIsFilterOpen,
    values,
    setValues,
    handleSubmit,
    customerData,
    handleDelete,
    setCurrentPage,
    selectedVoucher,
    setSelectedVoucher,
    packageCollect,
  };
};

export default useCustomerVouchers;
